import useSWR, { SWRResponse } from 'swr'
import { useEffect, useState } from 'react'
import UserTableRender from './table'
import axiosInstance from '../../../../utils/axiosInstance'
import { TableData } from '../../../../constants'
import { useDispatch, useSelector } from '../../../../store/store'
import { setTriggerAppUsersRefetch } from '../../../../store/slices/general'

const InternalUsers = () => {
  const dispatch = useDispatch()

  const [page, setPage] = useState(0)
  const defaultRowsPerPage = Number(localStorage.getItem('orderTableRowsPerPage')) || 5
  const [, setRowsPerPage] = useState(defaultRowsPerPage)

  const { internalUsersFilterQueryParams, internalUsersFilterQuerySearch: search } = useSelector(
    (state) => state.filters
  )

  const { triggerAppUsersRefetch } = useSelector((state) => state.general)

  const params: Record<string, unknown> = {
    internalUsers: true,
    name: search,
  }
  internalUsersFilterQueryParams && Object.assign(params, internalUsersFilterQueryParams)

  const {
    data: fetchedData,
    isLoading: loading,
    mutate,
  }: SWRResponse = useSWR('/app-users', (url) => axiosInstance.get(url, { params }))
  const data = fetchedData?.data?.appUsers

  let rowsData: TableData[] | [] = []
  if (data) {
    rowsData = data?.map((row) => {
      const { id, firstName, lastName, role, email, isAuthenticated } = row
      return {
        id,
        name: `${firstName} ${lastName}`,
        role,
        email,
        isAuthenticated,
      }
    })
  }

  useEffect(() => {
    mutate()
  }, [internalUsersFilterQueryParams, mutate, search])

  useEffect(() => {
    if (triggerAppUsersRefetch) {
      mutate()
      dispatch(setTriggerAppUsersRefetch(false))
    }
  }, [dispatch, mutate, triggerAppUsersRefetch])

  return (
    <div>
      <UserTableRender
        data={rowsData}
        defaultOrderBy={'name'}
        toolbar
        pagination
        densePadding
        isLoading={loading}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        rowsPerPageItemName="customerTableRowsPerPage"
      />
    </div>
  )
}

export default InternalUsers
